/* eslint-disable indent */
import router from 'next/router';
import tw from 'tailwind-styled-components';
import { PageLayout } from '../../components/Layout/PageLayout';
import { MobileAppDownloadBanner } from '../../components/MobileAppDownloadBanner/MobileAppDownloadBanner';
import { renderSection } from '../../services/section';
import {
  ArticleCategory,
  FooterSectionType,
  NavigationBarType,
  PageArticleType,
  PageSectionType,
  PreFootersType,
} from '../../types';
import { ArticleCard, BlogHeader } from '../components';
import { BlogBreadcrumbs } from '../components/Blog/BlogBreadcrumbs';
import { PreFooterTypesSection } from '../components/Sections/PreFooterTypesSection';

interface PageBlogCategoryProps {
  navBarSection: PageSectionType<NavigationBarType>;
  footerSection: PageSectionType<FooterSectionType>;
  preFooterType?: PreFootersType;
  page: ArticleCategory;
  articles: PageArticleType[];
  allArticles: PageArticleType[];
  overrideLogoUrl?: string;
}

export function PageBlogCategory(props: PageBlogCategoryProps): JSX.Element {
  const {
    page,
    navBarSection,
    footerSection,
    preFooterType,
    articles,
    allArticles,
    overrideLogoUrl,
  } = props;
  return (
    <PageLayout>
      {renderSection(
        navBarSection,
        undefined,
        undefined,
        undefined,
        undefined,
        overrideLogoUrl
      )}
      <MobileAppDownloadBanner />
      <BreadcrumbdsContainer>
        <BlogBreadcrumbs
          steps={[
            { title: 'Blog', link: '/blog' },
            {
              title: page.name,
              link: page.slug,
            },
          ]}
        />
      </BreadcrumbdsContainer>
      <BlogHeader title={page.name} allArticles={allArticles} />
      <ArticleGrid>
        {articles.map((article, i) => (
          <ArticleCard
            article={article}
            key={i}
            onClick={() => router.push(`/blog/article/${article.slug}`)}
          />
        ))}
      </ArticleGrid>
      {preFooterType && <PreFooterTypesSection data={preFooterType} />}
      {renderSection(footerSection)}
    </PageLayout>
  );
}

const ArticleGrid = tw.div`
  grid
  grid-cols-1
  lg:grid-cols-4
  gap-4
  mb-24
  px-8
  lg:px-36
`;

const BreadcrumbdsContainer = tw.div`
  w-full
  pl-8
  pt-8
`;
